import Highcharts from "highcharts";

if (typeof window !== "undefined") {
  window.Highcharts = Highcharts;
}

require("highcharts/modules/funnel");
require("highcharts/modules/heatmap");

Highcharts.setOptions({
  chart: {
    backgroundColor: "transparent",
    plotBackgroundColor: "transparent",
    style: { fontFamily: "inherit" },
  },
  credits: { enabled: false },
});

export default Highcharts;
